import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function referenciabancariaComboReducer(state= initialState.referenciabancariaCombo, action){
	switch(action.type){
		case types.GET_REFERENCIABANCARIAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}